import { render } from "./ListeCouleur.vue?vue&type=template&id=5fbbd822&ts=true"
import script from "./ListeCouleur.vue?vue&type=script&lang=ts"
export * from "./ListeCouleur.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__